import { gql } from '@apollo/client';
import { residualValueGridFragment } from './fragments';

export const RESIDUAL_VALUE_GRIDS = gql`
  query residualValueGrids($pager: PagerInputNew, $filters: ResidualValueGridFilters) {
    residualValueGrids(pager: $pager, filters: $filters) {
      total
      values {
        id
        code
        name
        fromDate
        toDate
        isActive
        stateId
        stateName
        isDeletable
      }
    }
  }
`;

export const RESIDUAL_VALUE_GRID = gql`
  query residualValueGrid($id: Int!) {
    residualValueGrid(id: $id) {
      ...residualValueGrid
    }
  }
  ${residualValueGridFragment}
`;

export const RESIDUAL_VALUE_GRID_STATE = gql`
  query residualValueGridState($id: Int!) {
    residualValueGridState(id: $id) {
      id
      name
      flowId
    }
  }
`;

export const RESIDUAL_VALUE_GRID_NEXT_STATES = gql`
  query residualValueGridNextStates($stateId: Int!) {
    residualValueGridNextStates(stateId: $stateId) {
      id
      name
    }
  }
`;

export const RESIDUAL_VALUE_GRID_STATE_HISTORY = gql`
  query residualValueGridStateHistory($id: Int!) {
    residualValueGridStateHistory(id: $id) {
      gridId
      flowId
      stateId
      stateName
      transitionMoment
      nextTransitionMoment
      userId
      userName
    }
  }
`;

export const RESIDUAL_VALUE_GRID_ITEMS = gql`
  query residualValueGridItems($id: Int!) {
    residualValueGridItems(id: $id) {
      gridId
      items {
        itemId
        itemName
      }
    }
  }
`;

export const RESIDUAL_VALUE_GRID_DETAILS = gql`
  query residualValueGridDetails($gridId: Int!, $itemId: Int) {
    residualValueGridDetails(gridId: $gridId, itemId: $itemId) {
      gridId
      itemId
      details {
        id
        itemId
        mileageFrom
        mileageTo
        period
        rvPercent
      }
    }
  }
`;

export const RESIDUAL_VALUE_GRID_DETAILS_ITEMS = gql`
  query residualValueGridDetailsItems($id: Int!) {
    residualValueGridItems(id: $id) {
      gridId
      items {
        itemId
        itemName
      }
    }
    residualValueGridDetails(gridId: $id) {
      gridId
      itemId
      details {
        id
        itemId
        mileageFrom
        mileageTo
        period
        rvPercent
      }
    }
  }
`;

export const RESIDUAL_VALUES = gql`
  query residualValues {
    residualValues {
      id
      name
    }
  }
`;
